import React, { Component } from 'react';
import  AuthService  from "../api/authentication.js";
import "./signup.css"
import {
  
    Redirect
  } from 'react-router-dom'
  

const Auth = new AuthService()
// https://uvune-events.herokuapp.com
class SignUp extends Component {
 
 constructor(props){
     super(props)
     this.state = {
          passwordcom:"",
          emailend:  "",
          emailerror:false,
          errorinput : "",
          emailmesage:"",
          errormesage:"",
          successful : false,
          email:[],
          loadingButton:false,
          noerorrpage :  true,
          disableBottom:true,
          domain: 'https://uvune-listing.herokuapp.com', 
      };
      this.props.noerorrpage(this.state.noerorrpage)
 }



submitSignup = (event)=>{
  
    event.preventDefault();
    // console.log("love")
    this.setState({
               loadingButton: true  
         })
    // if(this.state.emailerror){
    //     console.log(this.email.value, )
    //     if(!this.state.errormesage){
    //         console.log(this.email.value, this.schoolname.value, this.passwordconfir.value, this.fullname.value,this.password.value)
    //     }else{
    //         this.setState({
    //             errormesage:true,
    //             passwordcom:"judge is error"
    //         })
    //     }
    // }else{
    //     this.setState({
    //         emailmesage: "it ready taking else"
    //     })
    // }
    // console.log(this.email.value, this.passwordconfir.value,this.password.value)
   
    const data ={
        email:this.email.value,
        first_name :this.first_name.value,
        last_name :this.last_name.value,
        country : "Nigeria",
        mobile  : this.phone.value,
        // state : this.state1.value,
        // display_name :this.schoolname.value,
        password :this.password.value,
        // "phone_one": "01995843404",
    }
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' },
         body: JSON.stringify(data),
    };
    // console.log(" requestOptions",  requestOptions)
    fetch(this.state.domain+"/users", requestOptions)
    .then(res => res.json())
    .then((result)=>{
        if(result.message){
            this.setState({
                loadingButton:false,
                emailend:result.message.slice(79, -3)
            }) 
        }
          //const phoneend =     result.message.slice(57, -33)
        //   console.log("email end", result)  
       if(result.code === 409){    
          this.setState({
                emailerror:true,
                emailmesage: "This email address is already taken"       
          })
        //         if(this.state.emailend === this.email.value){
        //             // console.log("yes", this.state.emailend)  
        //             this.setState({
        //                 emailerror:true,
        //                 emailmesage: "This email address is already taken"       
        //             })
                   
        //             console.log(this.state.emailmesage)  
        //         }else{
        //          console.log("no")  
        //    }  
         } else{
        this.setState({
            successful: true,
            emailerror:false, 
        });
        
       
       }
        // result.message.slice(79, -3) get the erorr email meaasgae from back end
       // result.message.slice(57, -33) show error phone
       //result.message.slice(57, -37) show error email


    }).catch( (error) => {
        //   console.log("errro", error);
        //  console.log("error load", error )
     });
    
}

emailChange = () =>{
    this.setState({
        emailmesage: ""       
    })
}


passwordconfirChange =(event)=>{
    this.setState({value: event.target.value});
    // console.log("com", this.passwordconfir.value, "password",this.password.value)
    if(this.passwordconfir.value === this.password.value){
        // console.log("conform")
        this.setState({
            errormesage:false,
            passwordcom:"",
            disableBottom:false

        })
    }else{
        // console.log("not correct")
        this.setState({
            errormesage:true,
            disableBottom:true,
            passwordcom:"Passwords  confirmation do not match"
        })
        // console.log("not correct" , this.state. passwordcom)

    }
}
  render() {



    if(this.state.successful){
        return <Redirect to='/login' />
        //console.log("this.state.emailerror",this.state.emailerror)  
        // this.history.push('/login');
     }
  
    return (
            <div className=""> 
              <div className="login-fullbody" style={{marginBottom:"56px"}}>
                     <div className="login-img-body">
                        <img src="https://res.cloudinary.com/easywaya/image/upload/v1572959951/Uvune_logo_1_x38b7d.png"/>
                        </div>
                        
                        <div class="login-body-input">
                           <h4 class="login-body-input-h4">Create An Account</h4>
                          <hr/>
                          <form  onSubmit={this.submitSignup}    >
                          <div class="login-body-input-sub">
                            <div class="field">
                                    <label class="form-label"><small style={{fontSize:"70%"}}>First Name</small></label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                      ref={input => this.first_name = input } onChange={this.nameChange}
                                       placeholder="Enter First  Name" required
                                        />
                                    </div>
                           </div>
                           <div class="field">
                                    <label class="form-label"><small style={{fontSize:"70%"}}>Last Name</small></label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                        ref={input => this.last_name = input } onChange={this.nameChange} 
                                        placeholder="Enter Last Name" required
                                        />
                                    </div>
                           </div>
                           <div class="field">
                                    <label class="form-label"><small style={{fontSize:"70%"}}>Email Address</small></label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                        type="email" ref={input => this.email = input} 
                                        onChange={this.emailChange} placeholder="Enter Email Address " required
                                        />
                                    </div>
                                    {  this.state.emailerror?
                                            <div class="_9a1ab_k0UMi">
                                                {this.state.emailmesage}
                                            </div>   
                                                :
                                            ""
                                        } 
                           </div>
                          
                           <div class="field">
                                    <label class="form-label"><small style={{fontSize:"70%"}}>Phone Number</small></label>
                                    <div class="control">
                                        <input type="tel" class="input is-medium"
                                        onChange={this.handleChange} placeholder="Enter Phone Number" 
                                        ref={input=>this.phone = input}  required
                                        />
                                    </div>
                           </div>
                           <div class="field">
                                    <label class="form-label"><small style={{fontSize:"70%"}}>Password</small></label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                       type="password"ref={input => this.password = input }
                                        onChange={this.posswordChange} placeholder="Enter Password " required
                                        />
                                    </div>
                           </div>
                           <div class="field">
                                    <label class="form-label"><small style={{fontSize:"70%"}}>Password Confirmation</small></label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                        onChange={this.handleChange} type="email" 
                                        ref={input=>this.email = input}  required type="password" ref={input => this.passwordconfir = input } 
                                        onChange={this.passwordconfirChange} placeholder="Enter Password confirmation"
                                        />
                                    </div>
                                    
                                            <div class="_9a1ab_k0UMi">
                                              {this.state.passwordcom}
                                            </div>   
                                             
                           </div>
                           <div class="mt-20" style={{marginTop:"25px"}}>
                                {
                                    this.state. loadingButton?
                                    <div className="level-item">
                                        <a className="button is-loading is-large is-light">Loading</a>
                                    </div>   
                                        
                                    :  
                                    <div>
                                        {
                                            this.state.disableBottom ?
                                            <a class="button is-success" title="Disabled button" style={{width:"100%"}} disabled>Create an Account</a>
                                            :
                                            <button class="button is-success" style={{width:"100%"}}>Create an Account</button>
                                        }
                                      
                                    </div>
                                    
                                    // <button class="button button-cta btn-align .is-success is-fullwidth btn-outlined is-bold rounded raised no-lh">Login</button>
                                }
            
                                 
                            </div>

                           <div class="_8b6e4_2b_Za"><span>By signing up you accept our </span><a href="https://uvune.com/term" target="_blank" style={{color: "inherit"}}>terms and conditions</a></div>
                        </div>
                        </form>
                        <div class="f17a7_1fMa1">
                                <span style={{textAlign:"center"}}> Already have an Account? </span>
                                <a class="button is-danger is-outlined" style={{width:"100%",marginTop:"10px"}} href="/login">
                                    <span>Login</span>    
                                </a>
                                <a class="a5075_16PDh" href="/account/signup">  </a>
                            </div>
                    </div>   
                </div>      
           </div>     

    )

}





}

export default SignUp;


// WEBPACK FOOTER //
// ./src/component/signup/signup.js